import { render, staticRenderFns } from "./shopDetailsModal.vue?vue&type=template&id=028cc7b9&"
import script from "./shopDetailsModal.vue?vue&type=script&lang=js&"
export * from "./shopDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports